import { TomOption } from 'tom-select/src/types'
import { escape_html } from 'tom-select/src/utils'
import SelectableController from './selectable_controller'

const openFacilityIcon = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="h-4 w-4 text-accent shrink-0">' +
  '<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"></path>' +
  '</svg>'

export interface FacilityTomOption extends TomOption {
  name: string
  uid: string
  url: string
  invalid: boolean
}

export default class extends SelectableController {
  static values = {
    url: { type: String, default: '/facilities' },
    auditorId: { type: String, default: '' }
  }

  settings = {
    searchField: ['name', 'uid'],
    plugins: ['checkbox_options', 'remove_button', 'virtual_scroll']
  }

  declare auditorIdValue: string

  buildUrl (query: string): string {
    const url = new URL(this.urlValue, location.origin)
    url.searchParams.set('page', this.currentPage.toString())

    if (query === '' && this.auditorIdValue === '') {
      return url.toString()
    }

    url.searchParams.set('advanced_search', 'true')

    if (query !== '') {
      url.searchParams.set('q[g][0][c][0][a][0][name]', 'uid_text')
      url.searchParams.set('q[g][0][c][0][p]', 'cont')
      url.searchParams.set('q[g][0][c][0][v][0][value]', query)
      url.searchParams.set('q[g][0][c][1][a][0][name]', 'name')
      url.searchParams.set('q[g][0][c][1][p]', 'cont')
      url.searchParams.set('q[g][0][c][1][v][0][value]', query)
      url.searchParams.set('q[g][0][m]', 'or')
    }

    if (this.auditorIdValue !== '') {
      url.searchParams.set('q[g][1][c][0][a][0][name]', 'auditor_id')
      url.searchParams.set('q[g][1][c][0][p]', 'eq')
      url.searchParams.set('q[g][1][c][0][v][0][value]', this.auditorIdValue)
    }

    return url.toString()
  }

  renderOption (data: FacilityTomOption, escape: typeof escape_html): HTMLElement {
    const optionElement = document.createElement('div')
    const url = data.url ?? ''
    optionElement.innerHTML = `<div class="option-link"><div class="flex items-center space-x-1.5"><p>${escape(data.name)}</p>` +
      (url.length === 0 ? '' : `<a href="${escape(url)}" target="_blank">${openFacilityIcon}</a></div>`) +
      `<p class="text-sm font-normal text-secondary">${escape(data?.uid ?? '')}</p></div>`

    if (url.length > 0) {
      const facilityAnchor = optionElement.querySelector('a') as HTMLAnchorElement
      facilityAnchor.addEventListener('click', (event) => {
        event.stopPropagation()
      })
    }

    return optionElement
  }

  renderItem (data: FacilityTomOption, escape: typeof escape_html): HTMLElement {
    const optionElement = document.createElement('div')
    const url = data.url ?? ''
    let nameAndShortUid = escape(data.name)
    if (data.uid !== '' && data.uid !== undefined && data.uid !== null) {
      nameAndShortUid += `(${escape(data.uid.slice(0, 8))})`
    }

    optionElement.innerHTML = '<div class="flex flex-row items-center w-full">' +
      (url.length === 0 ? '' : `<a class="h-4 w-4" href="${escape(url)}" target="_blank">${openFacilityIcon}</a>`) +
      `<p class="px-1${data.invalid ? ' text-stm-error-solid' : ''}">${nameAndShortUid}</p></div>`

    if (url.length > 0) {
      const facilityAnchor = optionElement.querySelector('a') as HTMLAnchorElement
      facilityAnchor.addEventListener('click', (event) => {
        event.stopPropagation()
      })
    }

    return optionElement
  }

  changeAuditor ({ detail: { auditorId } }: { detail: { auditorId: string } }): void {
    this.auditorIdValue = auditorId
  }

  protected clearAndReload (): void {
    if (this.plugin == null) return

    this.plugin.clear(true)
    this.plugin.clearOptions()

    this.currentPage = 1
    this.nothingMoreToLoad = false

    this.plugin.load('')
  }

  auditorIdValueChanged (): void {
    this.clearAndReload()
  }
}
